import axios from 'axios';

// Ստուգում ենք, արդյոք API URL-ը սահմանված է
const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
    console.warn('REACT_APP_API_URL չի սահմանված .env ֆայլում: Օգտագործվում է localhost');
}

// Ստեղծում ենք Axios instance
const API = axios.create({
    baseURL: API_URL || 'http://localhost:5002',
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // Թույլատրում ենք հարցումներին ուղարկել cookie-ներ
});

// Request interceptor - ավելացնում է auth token-ը ամեն հարցման ժամանակ
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - մշակում է սխալները
API.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // CORS սխալների մշակում
        if (error.message === 'Network Error') {
            console.error('CORS կամ ցանցային սխալ:', error);
        }

        // 401 սխալների մշակում - token-ի ժամկետը լրացել է
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            // Այստեղ կարող եք ավելացնել վերահղում լոգին էջ
        }

        return Promise.reject(error);
    }
);

// API հարցումների հարմար մեթոդներ
const APIService = {
    // Products / courses — used by the registration form (Page3) to populate
    // the course list.
    getProducts: async (params = {}) => {
        const response = await API.get('/products', { params });
        return response.data;
    },
};

// Արտահանում ենք և API instance-ը, և հարմար մեթոդները
export { APIService };
export default API;